import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Api_Config from '../../code/api/ApiConfig';
import FileUploaderModalForm from "../FileUploaderModalForm";
import { ImportDocumentType } from "../../code/enums/Enums";
import BidPeriodFileGroupInfo from "../../code/models/BidPeriodFileGroupInfo";
import ApiDocument from "../../code/api/ApiDocument";
import Auth from "../../code/auth/Auth";
import AwardReportInfo from "../../code/models/AwardReportInfo";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";

interface IAdminAwardReportLoadReports {
    awardReportInfo: AwardReportInfo;
    onRefreshRequest: Function;
}

export default function AdminAwardReportLoadReports({ awardReportInfo, onRefreshRequest }: IAdminAwardReportLoadReports) {
    const bpFileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "fileName",
            title: "File Name",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "created",
            title: "Added",
            visible: true,
            formatData: formatDate,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "bidPeriodFileId",
            title: "",
            visible: true,
            formatData: buildViewDocumentColumn,
            type: CclDataTableColumnType.Data
        }
    ];

    function formatDate(val: Date) {
        let sval = ("" + val).replace("T", " ");
        val = new Date(sval);
        let dateStr = val.toISOString().split('T')[0];
        let time = new Intl.DateTimeFormat('en-us', { hour: '2-digit', minute: '2-digit', hour12: true }).format(val);
        return `${dateStr} ${time}`;
    }

    var comp = Api_Config.getSelectedCompany();

    function buildViewDocumentColumn(val: any, rowData: any) {
        let buttonClasses = "btn btn-primary btn-sm";
        let token = Auth.getAuthToken();
        return (
            <a className={buttonClasses} href={`${comp.adminApiUrl}/document/doc/${rowData.bidPeriodFileId}?t=${token}`} target="_blank" >View</a>
        )
    }

    function currentFileGroup(): BidPeriodFileGroupInfo {
        return awardReportInfo.fileGroup || new BidPeriodFileGroupInfo();
    }

    function handleCloseGroupConfirm(confirmed: boolean) {
        if (!confirmed) return;
        ApiDocument.completeFileGroup(currentFileGroup().bidPeriodFileGroupId).then(success => {
            if (success) {
                onRefreshRequest();
            }
        });
    }

    function handleFileGroupCreateClick() {
        ApiDocument.createFileGroupPrevBidPeriod(ImportDocumentType.award_report).then(success => {
            if (success) {
                onRefreshRequest();
            }
        });
    }

    function anyOpenFileGroup(): boolean {
        return !!awardReportInfo.fileGroup &&
            awardReportInfo.fileGroup.groupStatus.toLowerCase() === "ready";
    }

    function onUploadReportUploadSuccess() {
        onRefreshRequest();
    }

    return (
        <React.Fragment>
            <div>
                {!anyOpenFileGroup() &&
                    <div className="awardreport-btngroup">
                        <button className="btn btn-primary btn-sm" onClick={handleFileGroupCreateClick}>Create Report Group</button>
                    </div>
                }
                {!!anyOpenFileGroup() &&
                    <div className="awardreport-btngroup">
                        <ButtonConfirm enabled={true} buttonSolid={true}
                            buttonText={"Close Report Group"}
                            confirmTitle={"Close Group"}
                            confirmMessage={"Close current report group?"}
                            buttonSize={ButtonConfirmSize.Small}
                            onConfirm={handleCloseGroupConfirm} />
                        {/* <button className="" onClick={handleFileGroupDeleteClick}></button> */}
                        <FileUploaderModalForm
                            title="Upload Reports"
                            multiUpload={true}
                            fileGroup={ImportDocumentType.award_report}
                            fileGroupId={currentFileGroup().bidPeriodFileGroupId}
                            buttonTextChoose="Browse Documents"
                            buttonTextUpload="Upload Reports"
                            buttonTextMain="Add Reports To Group"
                            newGroupOnUpload={false}
                            onUploadSuccess={onUploadReportUploadSuccess} />
                        <span>Total Report Files: {currentFileGroup().bidPeriodFiles.length}</span>
                    </div>
                }
                {anyOpenFileGroup() &&
                    <React.Fragment>
                        <div className="awardreport-files-tablewrapper">
                            <CclDataTable
                                name={"awardReportFilesTable"}
                                tableData={currentFileGroup().bidPeriodFiles || []}
                                columnDefinitions={bpFileColumnDefs}
                                onRowSelect={null}
                                rowSelect={false}
                                onButtonClick={null} />
                        </div>
                    </React.Fragment>}
            </div>
        </React.Fragment >
    )
}

